import React, { useState, useEffect } from "react";
import { ScrollArea } from "../../components/ui/scroll-area";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import CALENDER_ICON from "../../assets/Calendar.png";
import CLOCK_ICON from "../../assets/Clock.png";
import { formatDate } from "../../utils/util-functions/formatDate";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import LOCK_ICON from "../../assets/Lock.png";
import LOCK_OPEN_ICON from "../../assets/LockSimpleOpen.png";
import EYE_ICON from "../../assets/Eye.png";
import { VIDEO_TYPE_YOUTUBE } from "../../constants/text_constants";
import { useNavigate } from "react-router-dom";
import { PROTECTED_ROUTES } from "../../routes/routes";
import userLogout from "../../utils/userLogout";
import { useDispatch } from "react-redux";
import { Button } from "../../components/ui/button";
import handleBuy from "../Buy/handleBuy";
import { ITEM_COURSE } from "../../constants/text_constants";

const ClassroomTabLectures = ({
  subjectId,
  defaultSubjectId,
  isPurchased,
  searchText,
  data,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [lecturesData, setLectureData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchSubjectLecture = async (retries = 6) => {
    try {
      const authToken = sessionStorage.getItem("token");
      // alert(authToken+"");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await fetch(
        process.env
          .REACT_APP_RANK_PLUS_COURSE_DETAILS_LIVE_CLASS_SUBJECT_LECTURES +
        (subjectId !== null ? subjectId : defaultSubjectId) +
        "&limit=250&page=" +
        currentPage,
        requestOptions
      );
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchSubjectLecture(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setLectureData(json?.data);
      setTotalPages(Math.ceil(json?.data?.total / 100));
    } catch (err) {
      console.error("Error fetchSubjectLecture : ", err);
    }
  };

  useEffect(() => {
    console.log("LECTURE ORIGIN:", window.location.origin);
console.log("LECTURE TOKEN:", sessionStorage.getItem("token"));
console.log("ALL SESSION:", { ...sessionStorage });
    fetchSubjectLecture();
  }, [subjectId, defaultSubjectId, currentPage]);

  if (!lecturesData) {
    return <div>.</div>;
  }

  function handleClick(video_type, id, subject_id) {
    const isLocked = lecturesData?.is_locked;
    if (isPurchased === "0") {
      if (!isLocked) {
        if (video_type === VIDEO_TYPE_YOUTUBE) {
          navigate(PROTECTED_ROUTES?.classroom + `/${id}/${subject_id}`);
        }
      } else {
        setIsModalOpen(true);
      }
    } else {
      if (!isLocked) {
        if (video_type === VIDEO_TYPE_YOUTUBE) {
          navigate(PROTECTED_ROUTES?.classroom + `/${id}/${subject_id}`);
        }
      }
    }
  }

  const filterLectures = (lectures, searchText) => {
    if (!searchText) return lectures;
    return lectures.filter(
      (lecture) =>
        lecture.title.toLowerCase().includes(searchText.toLowerCase()) ||
        lecture.description.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  return (
    <div>
      <ScrollArea className="w-full lg:w-[535px] rounded-md border px-4 overflow-auto max-h-[600px]">
        {filterLectures(lecturesData?.lectures, searchText)?.map((ele, i) => (
          <div
            key={i}
            onClick={() =>
              handleClick(ele?.video_type, ele?.id, ele?.subject_id)
            }
            className="
    my-3 bg-white rounded-xl
    border border-gray-200 p-3
    shadow-sm cursor-pointer
    flex items-center gap-3
  "
          >
            {/* Thumbnail */}
            <img
              src={ele?.thumbnail}
              alt={ele?.title}
              loading="lazy"
              className="w-[76px] h-[52px] rounded-lg object-cover flex-shrink-0"
            />

            {/* Middle Content */}
            <div className="flex-1 min-w-0">
              {/* Title */}
              <div className="font-semibold text-xs line-clamp-1">
                {ele?.title}
              </div>

              {/* Description (1–2 words on mobile) */}
              <div className="text-[10px] text-gray-500">
                <span className="inline-block max-w-[70px] truncate sm:max-w-none">
                  {stripText(stripHtml(ele?.description))}
                </span>
              </div>

              {/* Meta Info */}
              <div className="flex items-center gap-2 text-[10px] text-gray-400 mt-1">
                <div className="flex items-center gap-1">
                  <img src={CALENDER_ICON} className="w-3 h-3" />
                  {formatDate(ele?.created_at)}
                </div>
                <div className="flex items-center gap-1">
                  <img src={CLOCK_ICON} className="w-3 h-3" />
                  {ele?.video_length}
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="flex-shrink-0">
              {lecturesData?.is_locked ? (
                <div className="p-2 bg-[#03B3C3] rounded-full">
                  <img src={LOCK_ICON} className="w-4 h-4" />
                </div>
              ) : (
                <button
                  className="
          border border-[#5A277C]
          text-[#5A277C]
          px-3 py-1
          rounded-full
          text-[11px]
          whitespace-nowrap
          hover:bg-[#5A277C] hover:text-white transition
        "
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClick(ele?.video_type, ele?.id, ele?.subject_id);
                  }}
                >
                  VIEW
                </button>
              )}
            </div>
          </div>



        ))}
      </ScrollArea>
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent
          className="
      w-[90%] 
      max-w-sm 
      sm:max-w-md 
      lg:max-w-lg
      h-auto
      p-5
      rounded-xl
    "
        >
          <DialogHeader className="text-center">
            <DialogTitle className="text-xl sm:text-2xl text-[#5A277C] font-semibold">
              Buy Course
            </DialogTitle>

            <DialogDescription className="mt-2 text-sm sm:text-base">
              To access this course. Please buy this course 😊
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="mt-4 flex justify-center">
            <Button
              type="button"
              className="bg-[#5A277C] hover:bg-purple-700 w-full sm:w-auto"
              onClick={() =>
                handleBuy(
                  dispatch,
                  navigate,
                  data?.id,
                  ITEM_COURSE,
                  data?.name,
                  data?.offer_price,
                  data?.offer_discount,
                  data?.price,
                  data?.principal_amount,
                  data?.course_banner,
                  data?.course_icon
                )
              }
            >
              Buy Now
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

    </div>
  );
};

export default ClassroomTabLectures;
